module.exports = __webpack_public_path__ + "86a00ad50ab27ee478f7ec08fff0039f.MP3";